<template>
  <div class="content-card" ref="cardContent">
    <card :type="1" :title="'一级' + categoryName" :tableAcl="tableAcl" :isShowNo="isShowNo" :dataList="oneLevelCategoryData" @filterMethod="handleOneLevelSearch" @getChildrenData="getChildrenData" @handleAdd="handleAdd" @handleDelete="handleDelete" @handleUpdate="handleUpdate" />
    <card :type="2" :title="'二级' + categoryName" :tableAcl="tableAcl" :isShowNo="isShowNo" :dataList="twoLevelCategoryData" :isLast="true" @filterMethod="handleTwoLevelSearch" @handleAdd="handleAdd" @handleDelete="handleDelete" @handleUpdate="handleUpdate"></card>

    <el-dialog :title="title" :visible.sync="open" :center="true" width="500px" :before-close="cancel" :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <el-row v-if="isShowNo">
          <el-col :span="24">
            <el-form-item label="编码" prop="no">
              <el-input v-model="form.no" placeholder="请填写编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item :label="categoryName + '名称'" prop="name">
              <el-input v-model="form.name" :placeholder="'请填写' + categoryName + '名称'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
        <my-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</my-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  SaveSecondaryDictionary,
  RemoveSecondaryDictionarys,
  GetSecondaryDictionarysByTypeAndLevel,
} from "@/api";
import Card from "@/components/card";
import Content from "./content.vue";
import GetDataMixin from "@/mixin/getData-mixin";

export default {
  name: "assetsCategory",
  components: {
    Card,
    Content,
  },
  mixins: [GetDataMixin],
  data () {
    return {
      // 查询条件
      oneLevelQuery: {
        keyWord: "",
        pageSize: 1000,
        pageIndex: 1,
        level: 1,
        type: this.type,
      },
      twoLevelQuery: {
        keyWord: "",
        pageSize: 1000,
        pageIndex: 1,
        level: 2,
        type: this.type,
      },
      // 列表数据
      oneLevelCategoryData: [],
      twoLevelCategoryData: [],
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 新增、编辑的数据
      form: {},
      oneLevelActive: null,
      twoLevelActive: null,
      rules: {
        name: [
          {
            required: true,
            message: "请填写" + this.categoryName + "名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    categoryName: {
      type: String,
      default () {
        return "类型";
      },
    },
    type: {
      type: Number,
      default () {
        return 0;
      },
    },
    isShowNo: {
      type: Boolean,
      default () {
        return false;
      },
    },
  },
  methods: {
    getOneLevelData () {
      GetSecondaryDictionarysByTypeAndLevel(this.oneLevelQuery).then((res) => {
        this.oneLevelCategoryData = res.returnData.data;
      });
    },
    getTwoLevelData () {
      GetSecondaryDictionarysByTypeAndLevel(this.twoLevelQuery).then((res) => {
        this.twoLevelCategoryData = res.returnData.data;
      });
    },
    getChildrenData (id, type) {
      this.oneLevelActive = id;
      // this.twoLevelQuery.type = type + 1
      this.twoLevelQuery.parentId = id;
      this.getTwoLevelData();
    },
    handleOneLevelSearch (keyWord, type) {
      // this.oneLevelQuery.level = 1
      this.oneLevelQuery.keyWord = keyWord;
      this.getOneLevelData();

      this.oneLevelActive = null;
      this.twoLevelActive = null;
      this.twoLevelCategoryData = [];
    },
    handleTwoLevelSearch (keyWord, type) {
      // this.cityQuery.type = type
      this.twoLevelQuery.keyWord = keyWord;
      this.getTwoLevelData();
    },
    // 新建
    handleAdd (type) {
      if (type == 2 && !this.oneLevelActive) {
        this.$my_message(`请先选择一个一级${this.categoryName}`, "warning");
        return;
      }
      this.open = true;
      this.title = "新建" + this.getName(type);
      this.resetForm(type);

      if (type == 2) {
        this.form.parentId = this.oneLevelActive;
      }
    },
    getName (type) {
      let name = "一级" + this.categoryName;
      if (type == 2) {
        name = "二级" + this.categoryName;
      }
      return name;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "编辑" + this.getName(row.level);
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveSecondaryDictionary(this.form).then((res) => {
          this.open = false;
          this.$my_message(`执行成功`, "success");
          this.getData(this.form.level);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    getData (type) {
      if (type == 1) {
        this.getOneLevelData();
      } else if (type == 2) {
        this.getTwoLevelData();
      }
    },
    resetForm (type) {
      this.form = {
        name: "",
        level: type,
        type: this.type,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      this.$my_confirm("确认要中断当前操作吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.open = false;
        })
        .catch(() => { });
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("确认要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveSecondaryDictionarys({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData(row.level);
        })
        .catch(() => { });
    },
  },
  mounted () {
    // let content = document.getElementsByClassName('content')
    // console.log(content[0].style)
    // content[0].style.height = "calc(100vh - 90px)";
    this.getOneLevelData();
    this.$refs.cardContent.style.setProperty(
      "height",
      this.$parent.$el.clientHeight -
      this.$refs.cardContent.offsetTop +
      this.$parent.$el.offsetTop -
      50 +
      "px"
    );
  },
};
</script>

<style lang="scss" scoped>
// .content {
//   height: calc(100vh - 90px) !important;
// }
</style>
